import { put, call, all, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import get from 'lodash/get';
import {
  fetchSowDetailsSuccess,
  fetchSowDetailsFailure,
  setUpdateSowDetails,
  setDeleteSowDetails,
  addSowDetailsSuccess,
  addSowDetailsFailure,
  setUpdateSowDetailsFailure,
} from './actions';
import {
  FETCH_SOW_DETAILS,
  UPDATE_SOW_DETAILS,
  DELETE_SOW_DETAILS,
  ADD_SOW_DETAILS,
} from './types';
import axiosConfig from '../../services/axiosConfig';

function* fetchSowDetails({ id }) {
  try {
    const res = yield axiosConfig.get(`/sows?projectId=${id}`);
    const response = get(res, ['data', 'data'], {});
    // notification.destroy();
    if (res.status === 200) {
      yield put(fetchSowDetailsSuccess({ response }));
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
    }
  } catch (error) {
    yield put(fetchSowDetailsFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching the project details.',
      description: `${error}`,
    });
  }
}

/** Function to update Pipeline Section (Statement of Work) */
function* updateSowDetails({ data }) {
  try {
    const { id, ...body } = data;
    const res = yield axiosConfig.put(`/sow/${id}`, body);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      yield put(setUpdateSowDetails({ response }));
      notification.success({
        message: 'Pipeline Data Updated Successfully.',
      });
    } else {
      yield put(setUpdateSowDetailsFailure());
      notification.error({
        message: 'Something went wrong.',
      });
    }
  } catch (error) {
    yield put(setUpdateSowDetailsFailure());
    notification.destroy();
    notification.error({
      message: 'Pipeline Updation Failed.',
      description: `${error}`,
    });
  }
}

function* addSowDetails({ payload }) {
  try {
    const res = yield axiosConfig.post(`/sow`, payload);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      yield put(addSowDetailsSuccess({ response }));
      notification.success({
        message: 'Pipeline Data Added Successfully.',
      });
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
    }
  } catch (error) {
    yield put(addSowDetailsFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occured while adding the details.',
      description: `${error.error}`,
    });
  }
}

/** Function to delete Pipeline Section (Statement of Work) */
function* deleteSowDetails({ data }) {
  try {
    const res = yield axiosConfig.delete(`/sow/${data.id}`);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      yield put(setDeleteSowDetails({ data }));
      notification.success({
        message: 'Pipeline Data Deleted Successfully.',
      });
    } else {
      notification.error({
        message: 'Something went wrong. Please try again later.',
      });
    }
  } catch (error) {
    yield put(addSowDetailsFailure());
    notification.destroy();
    notification.warn({
      message: 'A problem occured while deleting the details.',
      description: `${error.error}`,
    });
  }
}

function* sowWatcher() {
  yield takeLatest(FETCH_SOW_DETAILS, fetchSowDetails);
  yield takeLatest(UPDATE_SOW_DETAILS, updateSowDetails);
  yield takeLatest(DELETE_SOW_DETAILS, deleteSowDetails);
  yield takeLatest(ADD_SOW_DETAILS, addSowDetails);
}

function* sowSagas() {
  yield all([call(sowWatcher)]);
}

export default sowSagas;
